/*
    Component for job Title Auto Suggestions.
*/
import React from 'react';

import lodash from 'lodash';
import { of, BehaviorSubject } from 'rxjs';
import {
   debounceTime,
   distinctUntilChanged,
   switchMap,
   map,
   catchError,
} from 'rxjs/operators';

import { getJobTitleSuggestions } from 'app/employer/services/JobService';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';

const getSuggestionValue = (suggestion) => {
   let div = document.createElement('div');
   div.innerHTML = suggestion.searchReplacement;
   return div.textContent;
};

const renderSuggestion = (suggestion) => (
   <div dangerouslySetInnerHTML={{ __html: suggestion.searchReplacement }}></div>
);

const reFormatSelection = (val) => {
   return lodash.isPlainObject(val) ? getSuggestionValue(val) : lodash.isString(val) ? val : '';
};

const jobTitleSuggestInput$ = new BehaviorSubject('');
const jobTitleSuggestObservable$ = jobTitleSuggestInput$.pipe(
   debounceTime(300),
   distinctUntilChanged(),
   switchMap((input) => {
      if (lodash.isPlainObject(input) && input.keyword && input.keyword.length > 2) {
         return getJobTitleSuggestions(input.keyword).pipe(
            map((data) => { return data.suggestions; }),
            catchError((error) => { console.log(error); return of([]); }),
         );
      } else {
         return of([]);
      }
   }),
);

const jobTitleSuggestObjectObservable$ = jobTitleSuggestInput$.pipe(
   debounceTime(300),
   distinctUntilChanged(),
   switchMap((input) => {
      if (lodash.isPlainObject(input) && input.keyword && input.keyword.length > 2) {
         return getJobTitleSuggestions(input.keyword).pipe(
            map((data) => {
               const suggestions = data && data.suggestions;
               return suggestions.map((suggestion) => {
                  return {
                     text: getSuggestionValue(suggestion),
                     name: getSuggestionValue(suggestion),
                     id: suggestion.id,
                  };
               });
            }),
            catchError((error) => { console.log(error); return of([]); }),
         );
      } else {
         return of([]);
      }
   }),
);

const JobTitleSuggestion = renderAutoSuggestWithOptions(
   jobTitleSuggestObservable$,
   jobTitleSuggestInput$,
   renderSuggestion,
   getSuggestionValue,
   reFormatSelection,
);

export const JobTitleSuggestionObject = renderAutoSuggestWithOptions(
   jobTitleSuggestObjectObservable$,
   jobTitleSuggestInput$,
);

JobTitleSuggestion.defaultProps = {
   value: '',
};

export default JobTitleSuggestion;
